<template>
    <div id="listVoucherPaymentMaintenance">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Voucher Payment Maintenance List</div>
                    <div class="btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="openModal()" >
                            <i class="fp-import"></i> Import
                        </a>
                    </div>    
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <data-table-filter-config :moduleName="'voucherPaymentMaintenanceList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchVpmMsg">Current batch {{batchNum}} is processing please wait!</p>
                        <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchVpmMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>
                        <section class="data-table bg-white">
                            <custom-pagination
                                :page-changed="onPageChange"
                                :per-page-changed="onPerPageChange" :moduleName="'voucherPaymentMaintenanceList'" :position="'top'">
                            </custom-pagination>
                            <vue-good-table
                                    ref="listVoucherPaymentMaintenance"
                                    mode="remote"
                                    @on-page-change="onPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-cell-click="onRowClick"
                                    :totalRows="totalRecords"
                                    @on-select-all="onSelectAll"
                                    title="Voucher Payment Maintenance"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :paginate="true"
                                    :paginationOptions="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                        enabled: true,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                        enabled: false,
                                    }"
                                >
                                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                    <div :key="key">
                                        <div>
                                            {{props.formattedRow[props.column.field]}}
                                        </div>
                                    </div>
                                </template>
                                <div slot="selected-row-actions">
                                    <button v-if="canDeleteUpload" id="VoucherPmtMaintBtn" v-on:click.prevent="deleteVoucherPmtMaintenance" class="btn btn-danger">Delete</button>
                                </div>
                            </vue-good-table>
                            <custom-pagination
                                :page-changed="onPageChange"
                                :per-page-changed="onPerPageChange">
                            </custom-pagination>
                        </section>    
                        <div class="modal fade voucher-payment-maintenance" id="voucher-payment-maintenance" ref="voucher-payment-maintenance" data-backdrop="static" data-keyboard="false" aria-labelledby="voucher-payment-maintenance" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Select File</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form id="importVpmFile" class="addinspectionForm">
                                            <div class="form-row">
                                                <div class="col form-group">
                                                    <label class="control-label require" for="payment_type">Payment Type:</label>
                                                    <v-select class="close-remove" v-model="payment_type" name="payment_type" placeholder="Select Payment Type." label="text" :options="paymentTypesArr">
                                                    </v-select>
                                                    <div class="field-error">{{payment_type_error_msg}}</div>
                                                </div>
                                                <div class="col form-group">
                                                    <label class="control-label require" for="payment_date">Payment Date:</label>
                                                    <div class="input-group">
                                                        <date-picker placeholder="MM/DD/YYYY" id="payment_date_maint" name="payment_date" v-model="payment_date" :config="optionsDate"></date-picker>
                                                        <label for="payment_date" class="fp-calendar input-calender-icon"></label>
                                                    </div>
                                                    <div class="field-error">{{ payment_date_error_msg }}</div>
                                                </div>
                                            </div>   
                                            <div class="form-row">
                                                <div class="col form-group">
                                                    <label class="control-label require mb-2" for="name">File:</label><br/>
                                                    <input id="voucherPaymentFile" type="file" @change="onFileChanged">
                                                    <div class="field-error">{{import_error}}</div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col form-group" v-if="fileName != ''">
                                                    <label class="control-label"> Download Sample file </label>
                                                    <a href="javascript:void(0)" v-on:click="downloadSample()"> <i class="fp-text-document"></i> {{fileName}} </a>
                                                </div>
                                            </div>
                                        </form>

                                        <div class="modal-footer">
                                            <button class="btn btn-tertiary" id="cancelButtonVpm" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                                            <button class="btn btn-primary" id="importButtonVpm" v-on:click="importVoucherData()"> <i class="fp-import"> </i> Import</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>        
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>    
    </div>    
</template>
<script>
import Vue from 'vue';
import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
import VueSSE from 'vue-sse'
Vue.use(VueSSE);
let msgServer;
import EventBus from ".././event-bus";

export default {
    name: "VoucherPaymentMaintenanceList",
    metaInfo: {
        title: "Voucher Payment Maintenance List | " +process.env.COPYRIGHT_NAME
    },
    mixins:[commonMixins,dataTableMixins,contractMixins],
    data: () => ({ 
        firstLoad:0,
        userColumns:[],
        columns:[
            {
                label: 'Batch',
                field: 'batch',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Batch", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }

            },
            {
                label: 'Payment Type',
                field: 'payment_type',
                fpFieldType:"option",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Payment Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter", //only trigger on enter not on keyup
                    filterDropdownItems:['ACH', 'CHECK'], // dropdown (with selected values) instead of text input
                }
            },
            {
                label: 'Payment Date',
                field: 'payment_date',
                fpFieldType:"date",
                html: false,
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }

            },
            {
                label: 'Upload Date',
                field: 'upload_date',
                fpFieldType:"date",
                html: false,
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }

            },
            {
                label: 'Records',
                field: 'total_records',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Records", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Error',
                field: 'error_records',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Records", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Amount',
                field: 'amount',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Status',
                field: 'status',
                fpFieldType:"option",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter", //only trigger on enter not on keyup
                    filterDropdownItems: ["Pending","In Progress","Confrimed"], // dropdown (with selected values) instead of text input
                }
            },
            {
                label: 'Created By',
                field: 'created_by',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Created By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }

            },
            {
                label: 'Created At',
                field: 'created_at',
                fpFieldType:"date",
                html: false,
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "created_at", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
        ],
        rows: [],
        totalRecords: 0,
        loading:false,
        permissions:[],
        cantAccessPage:'',
        action:'list',
        selectedFile:"",
        batchId:'',
        batchProcess:false,
        batchNum:'',
        file:'',
        import_error:'',
        fileName:'',
        canDeleteUpload:false,
        batchError:false,
        batchErrorMsg:"",
        paymentTypesArr:[],
        payment_type:"",
        payment_type_error_msg:"",
        payment_date:"",
        payment_date_error_msg:"",
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: true,
        }
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'list_voucher_payment_maintenance') {
                    self.cantAccessPage = true;
                }
                if(permissions.name == 'delete_voucher_payment_maintenance') {
                    self.canDeleteUpload = true;
                }
            });
            if (self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        }
    },
    created: function() {
        this.serverParams.sort = {field:"created_at",type:"desc"};
    },
    mounted: function () {
        var self = this;
        self.getPermissions();
        self.loadFieldData(['vendorInvoicePaymentTypes']);
    },
    methods: {
        cancelAll: function (cancelAll) {
            this.$refs.listVoucherPaymentMaintenance.unselectAllInternal();
        },
        checkBatchStatus:function(){
            var self = this;
            this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batchId, { format: 'json' }) // or { format: 'plain' }
            .then(sse => {
                // Store SSE object at a higher scope
                msgServer = sse;

                // Listen for messages without a specified event
                sse.subscribe('', data => {
                    if ( data.status == "1") {
                        self.batchProcess = false;
                        self.loadList();
                        sse.close();
                    }else if (data.status == "2") {
                        self.batchProcess = false;
                        self.batchError = true;
                        self.batchErrorMsg = data.message;
                        sse.close();
                    }
                });

            })
            .catch(err => {
                // When this error is caught, it means the initial connection to the
                // events server failed.  No automatic attempts to reconnect will be made.
                console.error('Failed to connect to server', err);
            });
        },
        loadList: function(){
            var self = this;
            var data = this.$refs['listVoucherPaymentMaintenance'].selectedRows;
            var use = [];
            for (var i = 0; i < data.length; i++) {
                use.push(this.$refs['listVoucherPaymentMaintenance'].selectedRows[i].id)
            }

            var self = this;
            self.loading =  true;
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/voucher-payment-maintenance/list",
                type: "POST",
                crossDomain: true,
                headers: this.ajxHeaders,
                dataType: "json",

                data:{
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: this.serverParams.columnFilters,
                    sort:self.serverParams.sort,
                    all:self.serverParams.selectedAll,
                    selectedRows:use,
                    action:self.action,
                },
                success: function (data) {
                    self.loading =  false;

                    if (data.status == "success") {
                        if (self.action == "delete") {
                            self.action = "list";

                            var msg = "";

                            msg = data.content+" records with Pending status have been deleted";

                            self.$swal('',msg,data.status);
                            EventBus.$emit('clear-all-flags', false);
                            self.loadList();
                            return;
                        }else{
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                        }
                    }

                },
                error: function (jqXHR, exception) {
                    self.loading =  false;
                    self.generateStatusCodeMessage(jqXHR, false, 'voucher-payment-maintenance-list')
                }
            });
        },
        openModal: function(){
            var self = this;
            if (self.batchProcess){
                self.$swal('','Previous batch already runnig','info');
                return;
            }
            self.selectedFile = "";
            $("#voucherPaymentFile").val('');
            self.import_error = '';
            self.generateExcelSample();
            self.payment_type = "";
            self.payment_type_error_msg = "";
            self.payment_date = "";
            self.payment_date_error_msg = "";
            $('#voucher-payment-maintenance').modal('show');
        },
        onFileChanged(event) {
            const file = event.target.files[0];
            var self = this;
            self.selectedFile = file;
            self.import_error = '';
        },
        importVoucherData() {
            var self = this;
            var error = false;
            self.import_error = "";
            self.payment_type_error_msg = "";
            self.payment_date_error_msg = "";

            if (!self.payment_type || self.payment_type == null || self.payment_type == "") {
                self.payment_type_error_msg = "Payment Type Required.";
                error = true;
            }

            if (self.payment_date == "" || self.payment_date == null) {
                self.payment_date_error_msg = "Payment Date Required.";
                error = true;
            }
            if( self.selectedFile == "" || self.selectedFile == null){
                self.import_error = "Please Select Excel File.";
                error = true;
            }else{
                var fileExtension = ['xls', 'xlsx'];
                if ($.inArray(self.selectedFile.name.split('.').pop().toLowerCase(), fileExtension) == -1) {
                    self.import_error = "Only formats are allowed : "+fileExtension.join(', ');
                    error = true;
                }
            }

            if (!error) {
                var formData = new FormData();
                formData.append('myFile', self.selectedFile);
                formData.append('paymentDate', self.payment_date);
                formData.append('paymentTypeId', self.payment_type.value);
                formData.append('paymentType', self.payment_type.code);
                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/voucher-payment-maintenance/import",
                    type: "POST",
                    data: formData,
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.batch_id){
                            self.batchProcess = true;
                            self.batchId = data.batch_id;
                            self.batchNum = data.batch;
                            self.checkBatchStatus();
                            $('#voucher-payment-maintenance').modal('hide');
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $('#importButtonVpm').text('Import');
                        $('#importButtonVpm').prop('disabled',false);
                        $('#cancelButtonVpm').prop('disabled',false);
                        self.generateStatusCodeMessage(jqXHR,true,'voucher-payment-maintenance-import-error')
                    }
                });
            }
        },
        generateExcelSample:function(){
            var self = this;
            $.ajax({
                url:
                process.env.ROOT_API +
                "/voucher-payment-maintenance/sample",
                type: "POST",
                crossDomain: true,
                dataType: "json",
                headers: this.ajxHeaders,

                success: function(data) {
                    self.loading = false;
                    self.fileName = data.content.file;
                    self.file = data.content.web;

                },
                error: function(jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'voucher-payment-maintenance-sample')

                }
            });
        },
        downloadSample(){
            var self = this;
            var docPath = self.file;
            var save = document.createElement('a');
            save.href = docPath;
            save.download = docPath;
            save.target = '_blank';
            document.body.appendChild(save);
            save.click();
            document.body.removeChild(save);
        },
        onRowClick(params,event) {
            var self = this;
            self.$router.push('/voucher-payment/maintenance/detail/'+params.row.id);
        },
        deleteVoucherPmtMaintenance() {
            var self = this;        
            self.$swal({
                title: 'Are you sure that you want to delete this Voucher Payment Maintenance?',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (result.value) {
                    self.action = "delete";
                    self.loadList();
                } else {
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/accounting/VoucherPaymentMaintenanceList.vue